const store = {
  state: () => ({
    list: [],
    isFetched: false,
    isFetching: false
  }),
  mutations: {},
  actions: {},
  getters: {}
}
export default store
